import { render, staticRenderFns } from "./Sidebar_v2.vue?vue&type=template&id=263c847c&scoped=true"
import script from "./Sidebar_v2.vue?vue&type=script&lang=js"
export * from "./Sidebar_v2.vue?vue&type=script&lang=js"
import style0 from "./Sidebar_v2.vue?vue&type=style&index=0&id=263c847c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263c847c",
  null
  
)

export default component.exports